import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './lib/session';
import { ErrorBoundary } from './components/ErrorBoundary';
import { App } from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Un solo tentativo in più: se il server non risponde, l'operatore deve
      // saperlo subito e passare agli altri canali del Comune, non guardare
      // una rotella per venti secondi durante un'emergenza.
      retry: 1,
      refetchOnWindowFocus: true,
    },
    mutations: {
      // Le mutazioni NON si ritentano: `publish` manda notifiche a migliaia di
      // persone e non è idempotente lato client. Un doppio invio silenzioso è
      // il peggior esito possibile di una rete lenta.
      retry: 0,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root non trovato');

createRoot(root).render(
  <StrictMode>
    {/* Il confine sta fuori da tutto, provider compresi, e non solo intorno ad
        `App`: un'eccezione dentro `AuthProvider` produce la stessa pagina
        bianca di una dentro una schermata, e il ripiego non ha bisogno né del
        router né delle query per disegnarsi. Più in alto sta, meno superficie
        resta scoperta. */}
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
